import React from "react";
import { useLocation } from "react-router-dom";

import { useAuthentication } from "./AuthenticationProvider";
import ApplicationLayoutProvider from "./layouts/ApplicationLayoutProvider";
import AuthLayoutProvider from "./layouts/AuthLayoutProvider";

export default function LayoutProvider({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const { user } = useAuthentication();

  const forceAuthLayout = pathname.startsWith("/join/");
  const noLayout =
    /^\/\d{6}$/.test(pathname) || // Do not show any layout for extension pages
    pathname.startsWith("/extension/") || // Do not show any layout for extension pages
    pathname === "/auth/tokens/new" || // Do not show any layout for the personal auth token page
    pathname === "/email_notification" || // Do not show any layout for notification confirmation
    pathname.split("/")[1] === "embed" || // Do not show any layout when the app is embedded
    pathname.startsWith("/quote/"); // Do not show any layout public quote pages

  if (!forceAuthLayout) {
    if (noLayout) return <div className="flex min-h-screen flex-col">{children}</div>;

    if (user) return <ApplicationLayoutProvider>{children}</ApplicationLayoutProvider>;

    // Allow access to the installation page without authentication
    if (pathname.startsWith("/welcome") || location.hostname.includes("livedocument")) return children;
  }

  return <AuthLayoutProvider>{children}</AuthLayoutProvider>;
}
